import { useState } from "react";
import ChecklistPanel from "./dd/ChecklistPanel";
import AnomaliesPanel from "./dd/AnomaliesPanel";
import MemorandumPanel from "./dd/MemorandumPanel";

const SECTIONS = [
    { v: "checklist", label: "Requests" },
    { v: "anomalies", label: "Anomalies" },
    { v: "memorandum", label: "Memorandum" },
];

/** Due Diligence Copilot — requests checklist, financial anomaly detection, investment memorandum. */
export default function DueDiligenceTab({ dealId, deal }) {
    const [section, setSection] = useState("checklist");
    // Each panel loads fresh on mount, so switching sections always shows current data
    // (e.g. an anomaly attached on one section is visible on the Requests section).
    return (
        <div className="space-y-4" data-testid="dd-tab">
            <div className="inline-flex rounded-md border border-border bg-white p-0.5">
                {SECTIONS.map((s) => (
                    <button key={s.v} onClick={() => setSection(s.v)} data-testid={`dd-section-${s.v}`}
                        className={`px-4 py-1.5 text-sm rounded ${section === s.v ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}>
                        {s.label}
                    </button>
                ))}
            </div>
            {section === "checklist" && <ChecklistPanel dealId={dealId} />}
            {section === "anomalies" && <AnomaliesPanel dealId={dealId} deal={deal} />}
            {section === "memorandum" && <MemorandumPanel dealId={dealId} />}
        </div>
    );
}
